/* TechRover - Real GLB Walkie Talkie loader (Three.js + GLTFLoader) */
(function () {
  function ready() {
    return typeof THREE !== 'undefined' && THREE.GLTFLoader;
  }
  function init() {
    if (!ready()) return setTimeout(init, 120);
    document.querySelectorAll('[data-walkie-3d]').forEach(mount);
  }

  function mount(el) {
    if (el.dataset.mounted === '1') return;
    el.dataset.mounted = '1';

    const accent = el.dataset.accent || '#076eba';
    const autoRotate = (el.dataset.autoRotate || el.dataset.auto_rotate || 'true') !== 'false';
    const modelUrl = el.dataset.modelUrl;
    if (!modelUrl) { console.warn('[walkie3d] missing data-model-url'); return; }

    const W = () => el.clientWidth || 480;
    const H = () => el.clientHeight || 620;

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(32, W() / H(), 0.1, 100);
    camera.position.set(0, 0.1, 8.4);

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(W(), H());
    if (THREE.SRGBColorSpace) renderer.outputColorSpace = THREE.SRGBColorSpace;
    el.appendChild(renderer.domElement);

    /* Lights */
    scene.add(new THREE.AmbientLight(0xffffff, 0.55));
    const key = new THREE.DirectionalLight(0xffffff, 1.2);
    key.position.set(3, 5, 5); scene.add(key);
    const rim = new THREE.PointLight(new THREE.Color(accent), 2.4, 16);
    rim.position.set(-3.5, 1.2, 2.5); scene.add(rim);
    const fill = new THREE.PointLight(0xffffff, 0.6, 14);
    fill.position.set(2.5, -2.5, 3); scene.add(fill);
    const top = new THREE.DirectionalLight(0xffffff, 0.4);
    top.position.set(0, 6, 1); scene.add(top);

    /* Group holds the loaded model */
    const walkie = new THREE.Group();
    scene.add(walkie);

    /* Ground shadow */
    const shadow = new THREE.Mesh(
      new THREE.CircleGeometry(1.5, 32),
      new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.32 })
    );
    shadow.rotation.x = -Math.PI / 2;
    shadow.position.y = -2.3;
    scene.add(shadow);

    /* Load GLB */
    const loader = new THREE.GLTFLoader();
    loader.load(modelUrl, (gltf) => {
      const model = gltf.scene || gltf.scenes[0];

      // Auto-center & scale to fit a target height
      const box = new THREE.Box3().setFromObject(model);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      model.position.sub(center); // center at origin
      const targetHeight = 3.4;
      const scale = targetHeight / (size.y || 1);
      model.scale.setScalar(scale);

      walkie.add(model);
    }, undefined, (err) => {
      console.error('[walkie3d] GLB load error', err);
    });

    /* Initial pose */
    walkie.rotation.y = -0.28;
    walkie.rotation.x = 0.06;
    walkie.position.y = -0.1;

    /* Interaction */
    let targetX = 0.06, targetY = -0.28;
    let curX = targetX, curY = targetY;
    let lastMove = performance.now();
    const stage = el.closest('.tr-stage') || el;

    function onPointer(clientX, clientY) {
      const rect = stage.getBoundingClientRect();
      const nx = ((clientX - rect.left) / rect.width) * 2 - 1;
      const ny = ((clientY - rect.top) / rect.height) * 2 - 1;
      targetY = nx * 0.95;
      targetX = -ny * 0.5;
      lastMove = performance.now();
      stage.style.setProperty('--tr-glow-x', ((clientX - rect.left) / rect.width * 100) + '%');
      stage.style.setProperty('--tr-glow-y', ((clientY - rect.top) / rect.height * 100) + '%');
    }

    window.addEventListener('mousemove', (e) => onPointer(e.clientX, e.clientY), { passive: true });
    el.addEventListener('touchmove', (e) => {
      if (e.touches[0]) onPointer(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    window.addEventListener('deviceorientation', (e) => {
      if (e.gamma == null || e.beta == null) return;
      targetY = (e.gamma / 45) * 0.9;
      targetX = (e.beta / 90) * 0.4;
      lastMove = performance.now();
    });

    function resize() {
      renderer.setSize(W(), H());
      camera.aspect = W() / H();
      camera.updateProjectionMatrix();
    }
    window.addEventListener('resize', resize);
    if (window.ResizeObserver) new ResizeObserver(resize).observe(el);

    function tick() {
      const now = performance.now();
      const idle = autoRotate && (now - lastMove) > 1800;
      if (idle) {
        targetY = Math.sin(now * 0.0006) * 0.8;
        targetX = Math.sin(now * 0.0004) * 0.16;
      }
      curX += (targetX - curX) * 0.08;
      curY += (targetY - curY) * 0.08;
      walkie.rotation.x = curX;
      walkie.rotation.y = curY;
      walkie.position.y = -0.1 + Math.sin(now * 0.0012) * 0.06;
      renderer.render(scene, camera);
      requestAnimationFrame(tick);
    }
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
